import React, { useEffect, useState } from 'react';
import DateTimePicker from '../../../ReusableComponents/DateTimePicker';
import Modal from '../../../ReusableComponents/Modal';
import { GLOBAL_STYLES } from '../../../appConstants';
import { Button } from '../../../Components/Helper';

const DSPInvoicesFilter = ({ filter, onFilterChange, open, onClose }) => {
    const [dspInvoiceFilter, setDspInvoiceFilter] = useState(filter);

    const handleFilterChange = (updatedFilter) => {
        setDspInvoiceFilter(updatedFilter);
    };


    useEffect(() => {
        const fromDate = new Date(dspInvoiceFilter.fromDate);
        let toDate = new Date(dspInvoiceFilter.toDate);
        const isSameDay = fromDate.toDateString() === toDate.toDateString()
        if (isSameDay && dspInvoiceFilter.toDate) {
            if (toDate.getTime() <= fromDate.getTime()) {
                toDate = new Date(fromDate.getTime() + 5 * 60 * 1000);
                handleFilterChange({
                    ...dspInvoiceFilter,
                    toDate
                });
            }
        }

    }, [dspInvoiceFilter.fromDate, dspInvoiceFilter.toDate])
    return (
        <Modal
            header={"Filter"}
            contentStyle={{ width: "730px", height: "auto" }}
            headingStyle={{ fontSize: "18px", fontWeight: 600 }}
            headerContainerStyle={{ padding: "20px" }}
            open={open}
            onClose={onClose}
        >
            <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
                {/* Date Filter Section */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "8%" }}>
                    <DateTimePicker
                        title="From"
                        hideNxt={new Date()}
                        selectedDateTime={dspInvoiceFilter.fromDate}
                        minTime={new Date().setHours(0, 0)}
                        maxTime={new Date().setHours(23, 59)}
                        onChange={(date) => {
                            handleFilterChange({
                                ...dspInvoiceFilter,
                                fromDate: new Date(date).toISOString()
                            });
                        }}
                    />
                    <DateTimePicker
                        title="To"
                        hidePrev={dspInvoiceFilter.fromDate}
                        selectedDateTime={dspInvoiceFilter.toDate}
                        toMinDate={new Date(dspInvoiceFilter.fromDate)}
                        minTime={new Date(dspInvoiceFilter?.fromDate).toDateString() === new Date(dspInvoiceFilter?.toDate).toDateString()
                            ? new Date(new Date(dspInvoiceFilter.fromDate).setMinutes(new Date(dspInvoiceFilter.fromDate).getMinutes() + 1))
                            : new Date().setHours(0, 0, 0, 0)}
                        onChange={(date) => {
                            let toDate = new Date(date);
                            if (!dspInvoiceFilter.toDate) {
                                toDate = new Date(toDate).setHours(23, 59, 59, 999);
                                toDate = new Date(toDate);
                            }
                            handleFilterChange({
                                ...dspInvoiceFilter,
                                toDate: toDate.toISOString()
                            });
                        }}
                        isDisable={!(dspInvoiceFilter.fromDate)}
                    />
                </div>
              
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 30px", borderTop: '0.5px solid #BFC8D9' }}>
                <div
                    onClick={async () => {
                        setDspInvoiceFilter({
                            ...dspInvoiceFilter,
                             paymentMode:undefined,
                            fromDate: undefined,
                            toDate: undefined,
                            states:[],
                        })
                    }} style={{ width: "100px", color: GLOBAL_STYLES.BG_ACTIVE, fontWeight: 600, fontSize: "14px", cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: "start" }}>
                    Clear all
                </div>
                <Button
                    text={"Apply"}
                    style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}
                    onClick={() => {
                        onFilterChange(dspInvoiceFilter)
                    }}
                />
            </div>
        </Modal>
    );
};

export default DSPInvoicesFilter;